import { getPageUrl } from "utils/getPageUrl";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import type { LanguageCode } from "config/languages";
import type { StickyBottomBarProps } from "../StickyBottomBar.d";

const BOTTOM_BAR_AIRHELP_PLUS_EVENT_UA = ["clicked", "BottomBar", "AirhelpPlus"] as const;
const BOTTOM_BAR_CHECK_COMPENSATION_EVENT_UA = ["clicked", "BottomBar", "CheckYourCompensation"] as const;

const BOTTOM_BAR_AIRHELP_PLUS_EVENT = {
  event: "cta_click",
  label: "airhelp_plus",
  placement: "sticky_bottom_bar",
} as const;
const BOTTOM_BAR_CHECK_COMPENSATION_EVENT = {
  event: "check_compensation",
  label: "check_your_compensation",
  placement: "sticky_bottom_bar",
} as const;

const getCTAElementProps = (language: LanguageCode, variant: StickyBottomBarProps["variant"]) => {
  let handletrackEvents = () => {
    trackUAEvent(BOTTOM_BAR_CHECK_COMPENSATION_EVENT_UA);
    trackCustomEvent(BOTTOM_BAR_CHECK_COMPENSATION_EVENT);
  };

  if (variant === "ahPlus") {
    handletrackEvents = () => {
      trackUAEvent(BOTTOM_BAR_AIRHELP_PLUS_EVENT_UA);
      trackCustomEvent(BOTTOM_BAR_AIRHELP_PLUS_EVENT);
    };

    return {
      href: getPageUrl(language, "airhelpPlus"),
      onClick: handletrackEvents,
    };
  }
  return {
    href: getPageUrl(language, "webappNewClaim"),
    target: "_blank",
    onClick: handletrackEvents,
  };
};

export { getCTAElementProps };
